import {Space} from 'antd';
import styled from 'styled-components';

const StyledVendorInvoices = styled(Space)`
  width: 100%;
`;


export {
  StyledVendorInvoices,
}